import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api"; // ✅ shared axios client

function AddWorkOrder() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    date: "",
    line: "",
    custom_line: "",
    machine: "",
    task: "",
    lead_time: "",
    assignee: "",
    scheduled_date: "",
    status: "open",
    type: "",
  });

  const [team, setTeam] = useState([]);

  const lines = [
    "Line A","Line B","Line C","Line D","Shirataki","Juten","1Gal","Fryer",
    "Multivac","Building","Production","SQF","Okara","Recieving","Soaking",
    "Casing","Utility","HVAC","Fire Alarm System","Cooler","other"
  ];

  const machines = [
    "Silo","Scale unit","Conveyor","Grinder","Cooker","surge Tank","Separator",
    "Turn Table","Steam Tunnel","Morikomi","Traverser","Press Machine","Steamer","printer",
    "Alkali CV","Pasteurizer","Automation","Topia","Scal","DPX","Boil&cool",
    "Metal Detector","Taper Machine","Packing Machine","wall","Floor","tank","vibratoy conveyor","vibratory device","electrical part",
    "Dea unit","softener","reverse machine","cutting machine","Staires","pipes","Ceiling","Okara room","Okara Dumpster","Heat exchanger","Kneader",
    "conveyor","preparation tank","sink","RTU","MAU","E.V","Fire supression system","Alarm System",
    "Boiler","Compressor","Chiller","Cooling tower","small dust collector","Large dust collector","Blower","large Cooler","small Cooler","Other"
  ];

  const types = ["Preventive", "Corrective", "Predictive", "Project"];

  useEffect(() => {
    api
      .get("/api/team")
      .then((res) => setTeam(res.data || []))
      .catch((err) => {
        console.error("Error fetching team", err);
        setTeam([]);
      });
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      line: formData.line === "Other" ? formData.custom_line : formData.line,
    };

    // Optional: avoid sending custom_line to backend (not needed)
    delete dataToSend.custom_line;

    try {
      await api.post("/api/work-orders", dataToSend);
      alert("✅ Work Order created successfully!");
      navigate("/work-orders");
    } catch (err) {
      console.error("Error creating work order", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Unknown error";
      alert(`❌ Failed to create work order: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ Add New Work Order</h1>
      <form onSubmit={handleSubmit}>
        {/* Date */}
        <div>
          <label>Created Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        {/* Line */}
        <div>
          <label>Line:</label>
          <select
            name="line"
            value={formData.line}
            onChange={handleChange}
            required
          >
            <option value="">Select Line</option>
            {lines.map((l) => (
              <option key={l} value={l}>
                {l}
              </option>
            ))}
          </select>

          {formData.line === "Other" && (
            <div>
              <label>Custom Line Name:</label>
              <input
                type="text"
                name="custom_line"
                value={formData.custom_line}
                onChange={handleChange}
                placeholder="Enter new line name"
                required
              />
            </div>
          )}
        </div>

        {/* Machine */}
        <div>
          <label>Machine:</label>
          <select
            name="machine"
            value={formData.machine}
            onChange={handleChange}
            required
          >
            <option value="">Select Machine</option>
            {machines.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        {/* Task */}
        <div>
          <label>Task Description:</label>
          <textarea
            name="task"
            value={formData.task}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        {/* Type */}
        <div>
          <label>Work Order Type:</label>
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            required
          >
            <option value="">Select Type</option>
            {types.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        {/* Lead Time */}
        <div>
          <label>Lead Time:</label>
          <input
            type="date"
            name="lead_time"
            value={formData.lead_time}
            onChange={handleChange}
            required
          />
        </div>

        {/* Assignee */}
        <div>
          <label>Work By (Assignee):</label>
          <select
            name="assignee"
            value={formData.assignee}
            onChange={handleChange}
            required
          >
            <option value="">Select Technician</option>
            {team.map((tech) => (
              <option key={tech.id} value={tech.full_name}>
                {tech.full_name}
              </option>
            ))}
          </select>
        </div>

        {/* Scheduled Date */}
        <div>
          <label>Scheduled Date:</label>
          <input
            type="date"
            name="scheduled_date"
            value={formData.scheduled_date}
            onChange={handleChange}
          />
        </div>

        <br />
        <button type="submit">Submit Work Order</button>
      </form>
    </div>
  );
}

export default AddWorkOrder;
